export default "__VITE_ASSET__C$K2UKGp__"